<template>
  <SidePopup
    :title="title"
    v-on:close="onClose"
    @submit="onSubmit"
    :loading="isLoading"
    routeback="/fornecedor/cadastro/caracteristica-cliente"
  >
    <FormField
      label="Nome"
      v-model="form.nome"
      :validation="$v.form.nome"
      @blur="onBlurName"
    />
    <FormField
      label="Nome interno"
      v-model="form.nome_interno"
      :validation="$v.form.nome_interno"
      :help="nomeInternoHelp"
      v-stringscaped
    />
    <FormSelect
      label="Canais de venda"
      v-model="form.canais_venda"
      :options="canaisVendaOptions"
      :multiple="true"
      :help="canaisVendaHelp"
      :validation="$v.form.canais_venda"
    />
    <FormSwitch
      v-model="form.exibir_no_formulario"
      label="Exibir no formulário de cadastro"
    />
    <FormSelect label="Tipo" v-model="form.tipo" :options="types" />
    <v-row v-if="isArray">
      <v-col>
        <FormField label="Nome do item da característica" v-model="item" />
      </v-col>
      <v-col cols="auto">
        <FormButton text="Adicionar" @click="addItem" />
      </v-col>
    </v-row>
    <v-row v-if="isArray" class="mt-n7 mb-7">
      <v-col
        v-for="(item, i) in form.itens_caracteristica"
        :key="i"
        cols="auto"
      >
        <v-chip class="py-5" color="primario">
          <h3 class="ml-3">{{ item }}</h3>
          <v-icon size="17" class="ml-4 delete-item" @click="removeItem(i)">
            fa-trash
          </v-icon>
        </v-chip>
      </v-col>
    </v-row>
    <FormSwitch
      v-if="isArray"
      v-model="form.multiplo"
      label="Permitir seleção de vários itens"
    />
    <FormSwitch
      v-if="!isBoolean || isArray"
      v-model="form.obrigatorio"
      label="O campo é obrigatório"
    />
    <FormSwitch
      v-if="!isDocumento"
      v-model="form.permite_alteracao_erp"
      label="Permitir que a integração desvincule clientes desta característica"
    />
    <template v-slot:buttons>
      <FormButton text="Salvar" submit type="submissao" />
    </template>
  </SidePopup>
</template>

<script>
import FormSelect from "@/components/form/FormSelect";
import FormButton from "@/components/form/FormButton";
import FormSwitch from "@/components/form/FormSwitch";
import FormField from "@/components/form/FormField";
import { required } from "vuelidate/lib/validators";
import SidePopup from "@/components/SidePopup";
import {
  CARACTERISTICA_CLIENTE_LOAD,
  CARACTERISTICA_CLIENTE_CREATE,
  CARACTERISTICA_CLIENTE_UPDATE
} from "@/store/actions/caracteristicaCliente";
import { CANAIS_VENDA_OPTIONS_DESMARCAVEIS } from "@/utils/canais-venda";
import {
  NOME_INTERNO_HELP,
  CANAIS_VENDA_HELP,
  TIPOS_CARACTERISTICA_CLIENTE,
  createDefaultCaracteristicaForm,
  mapCaracteristicaFromApi,
  buildCaracteristicaSubmitPayload,
  canSubmitCaracteristica
} from "./canais-venda-helpers";
import StringUtils from "../../../../utils/stringUtils";
export default {
  name: "caracteristicaClienteForm",
  components: {
    SidePopup,
    FormField,
    FormButton,
    FormSwitch,
    FormSelect
  },
  validations: {
    form: {
      nome: { required },
      nome_interno: { required },
      canais_venda: { required }
    }
  },
  data: () => ({
    mode: "add",
    types: TIPOS_CARACTERISTICA_CLIENTE,
    item: "",
    canaisVendaOptions: CANAIS_VENDA_OPTIONS_DESMARCAVEIS,
    nomeInternoHelp: NOME_INTERNO_HELP,
    canaisVendaHelp: CANAIS_VENDA_HELP,
    form: createDefaultCaracteristicaForm(),
    isLoading: false
  }),
  methods: {
    onBlurName() {
      if (!this.form.nome_interno) {
        this.form.nome_interno = StringUtils.normalizeUrl(this.form.nome);
      }
    },
    applyLoadedForm(resp) {
      this.form = mapCaracteristicaFromApi(resp);
    },
    buildSubmitPayload() {
      return buildCaracteristicaSubmitPayload(this.form, this.isArray);
    },
    getData(id) {
      this.isLoading = true;
      this.$store
        .dispatch(CARACTERISTICA_CLIENTE_LOAD, id)
        .then(resp => {
          this.isLoading = false;
          this.applyLoadedForm(resp);
        })
        .catch(() => this.onClose(true));
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) return;
      if (this.isArray && !this.form.itens_caracteristica.length) {
        this.$vueOnToast.pop(
          "error",
          "Adicione ao menos um item ao intervalo de valores"
        );
        return;
      }
      if (!this.isArray) {
        this.form.itens_caracteristica = [];
        this.form.multiplo = false;
      }
      const payload = this.buildSubmitPayload();
      if (!canSubmitCaracteristica(payload)) return;
      this.isLoading = true;
      if (this.mode == "add") {
        this.$store
          .dispatch(CARACTERISTICA_CLIENTE_CREATE, payload)
          .then(() => {
            this.$vueOnToast.pop(
              "success",
              `Característica cadastrado com sucesso`
            );
            this.onClose(true);
          })
          .catch(() => (this.isLoading = false));
      } else {
        this.$store
          .dispatch(CARACTERISTICA_CLIENTE_UPDATE, payload)
          .then(() => {
            this.$vueOnToast.pop(
              "success",
              "Característica atualizado com sucesso"
            );
            this.onClose(true);
          })
          .catch(() => (this.isLoading = false));
      }
    },
    onClose(routeBack = false) {
      this.isLoading = false;
      this.$emit("close");
      if (routeBack) {
        this.$router.replace("/fornecedor/cadastro/caracteristica-cliente");
      }
    },
    addItem() {
      if (!this.item) return;
      if (!this.form.itens_caracteristica) {
        this.form.itens_caracteristica = [];
      }
      this.form.itens_caracteristica.push(this.item);
      this.item = "";
    },
    removeItem(index) {
      this.form.itens_caracteristica.splice(index, 1);
    }
  },
  computed: {
    title() {
      return this.mode == "edit"
        ? "Editar característica de cliente"
        : "Nova característica de cliente";
    },
    isBoolean() {
      return this.form.tipo === "boolean";
    },
    isArray() {
      return this.form.tipo === "array";
    },
    isDocumento() {
      return this.form.tipo === "documento";
    }
  },
  created() {
    let idRoute = this.$route.params.id;
    if (idRoute !== "novo") {
      this.mode = "edit";
      this.getData(idRoute);
    } else {
      this.editable = true;
    }
  }
};
</script>

<style scoped>
.delete-item {
  border-radius: 50%;
  background-color: white !important;
  color: red !important;
  padding: 6px;
}
</style>
